import type { DemoKey } from './keys';

export const th: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'เรขาคณิต · 3D',
  'panel.figure': 'รูปทรง',
  'panel.dims': 'ขนาด',
  'panel.style': 'รูปลักษณ์',
  'panel.lines': 'เส้นพิเศษ',
  'style.body': 'ตัว',
  'style.line': 'เส้น',
  'style.cut': 'หน้าตัด',
  'style.labels': 'ป้ายจุดยอด',
  'group.face': 'เส้นทแยงมุมหน้า / เส้นกำเนิด',
  'group.space': 'เส้นทแยงมุม / แกน / มัธยฐาน',
  'split.label': 'หน้าตัด',
  'btn.animate': 'แอนิเมชัน',
  'btn.reset': 'รีเซ็ต',
  'hint.line1': 'ลากเพื่อหมุน · เลื่อนเพื่อย่อขยาย',
  'hint.line2': 'คลิกเส้นเพื่อเลือก',
  'fig.cuboid': 'ทรงสี่เหลี่ยมมุมฉาก',
  'fig.cube': 'ลูกบาศก์',
  'fig.triPrism': 'ปริซึมสามเหลี่ยม',
  'fig.hexPrism': 'ปริซึมหกเหลี่ยม',
  'fig.tetrahedron': 'จัตุรมุข',
  'fig.squarePyramid': 'พีระมิดฐานสี่เหลี่ยม',
  'fig.cylinder': 'ทรงกระบอก',
  'fig.cone': 'กรวย',
  'fig.sphere': 'ทรงกลม',
  'fig.frustumPyramid': 'พีระมิดตัด',
  'fig.frustumCone': 'กรวยตัด',
  'dim.length': 'ความยาว',
  'dim.width': 'ความกว้าง',
  'dim.height': 'ความสูง',
  'dim.side': 'ด้าน',
  'dim.radius': 'รัศมี',
  'dim.r1': 'รัศมีล่าง',
  'dim.r2': 'รัศมีบน',
  'dim.sideBase': 'ด้านฐาน',
  'dim.sideTop': 'ด้านบน',
  'info.face': 'หน้า',
  'info.center': 'ผ่านศูนย์',
  'info.diagonal': 'แนวทแยง',
  'info.axial': 'แนวทแยงแกน',
  'info.diameter': 'เส้นผ่านศูนย์กลาง',
  'info.generator': 'เส้นกำเนิด',
  'info.axis': 'แกน',
  'info.height': 'ความสูง',
  'info.median': 'มัธยฐาน',
  'info.apothem': 'อะโพเทม',
  'info.diameterBase': 'เส้นผ่านศูนย์กลางฐาน',
  'info.diameterTop': 'เส้นผ่านศูนย์กลางบน',
};
